module.exports = __webpack_public_path__ + "img/done-all.f18dbaa7.svg";